import { Observable } from 'rxjs';
import { DocumentsRepository } from '../domain/documents/repository';

import HttpClient from '../utils/http-client';

export class DocumentsRepositoryImplementation extends DocumentsRepository {
    getElectronicDocumentsSettings(uid: string, cid: string | null): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/documents/settings`);
    }

    toggleEnableSettings(uid: string, cid: string | null, id: number, enable: boolean): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.put(`/documents/settings/${id}/enable`, { enable });
    }

    updateResolution(uid: string, cid: string | null, id: number, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.put(`/documents/settings/${id}`, data);
    }

    addResolution(uid: string, cid: string | null, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/documents/settings`, data);
    }

    getAllCreditNotes(uid: string, cid: string | null, page: number, limit: number): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/sells/credit-notes?page=${page}&limit=${limit}`);
    }

    getAllInvoices(uid: string, cid: string | null, page: number, limit: number, status?: string, date_from?: string, date_to?: string, origin?: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        const params = new URLSearchParams({ page: String(page), limit: String(limit) });
        if (status) params.append('status', status);
        if (date_from) params.append('date_from', date_from);
        if (date_to) params.append('date_to', date_to);
        if (origin) params.append('origin', origin);
        return httpClient.get(`/sells/invoices?${params.toString()}`);
    }

    getConflictedSales(uid: string, cid: string | null, page: number, limit: number, origin?: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        const params = new URLSearchParams({ page: String(page), limit: String(limit) });
        if (origin) params.append('origin', origin);
        return httpClient.get(`/sells/conflicts?${params.toString()}`);
    }

    resolveConflict(uid: string, cid: string | null, bill_id: number, force_generate: boolean): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/sells/conflicts/${bill_id}/resolve`, { force_generate });
    }


    //OLD
    redirectToInvoice(id: number): Observable<any> {
        const httpClient = new HttpClient("", "");
        return httpClient.get(`/invoice/redirect/${id}`);
    }



    createCreditNote(prefix: string, invoiceNumber: number): Observable<any> {
        const uid = localStorage.getItem('uid') || "";
        const cid = localStorage.getItem('cid') || "";
        const httpClient = new HttpClient(uid, cid);
        return httpClient.put(`/sells/${prefix}/${invoiceNumber}/cancel`, {});
    }

    getInvoiceResolutions(uid: string, cid: string | null): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/invoice/resolutions`);
    }


    createInvoice(uid: string, cid: string | null, data: any): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/invoice`, data);
    }

    getInvoiceByNumber(uid: string, cid: string | null, number: number, prefix: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/invoice/number/${number}/${prefix}`);
    }

    getInvoiceByCude(uid: string, cid: string | null, cude: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/invoice/cude/${cude}`);
    }

    getInvoicePDF(uid: string, cid: string | null, cude: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/invoice/pdf/${cude}`);
    }



    emitSupportDocument(uid: string, cid: string | null, data: { document_id: number; document_type: string; notes?: string }): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/support-documents/emit`, data);
    }

    getSupportDocuments(uid: string, cid: string | null, page: number, limit: number, status?: string, model?: string, date_from?: string, date_to?: string, search?: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        const params = new URLSearchParams({ page: String(page), limit: String(limit) });
        if (status) params.append('status', status);
        if (model) params.append('model', model);
        if (date_from) params.append('date_from', date_from);
        if (date_to) params.append('date_to', date_to);
        if (search) params.append('search', search);
        return httpClient.get(`/support-documents?${params.toString()}`);
    }

    cancelSupportDocument(uid: string, cid: string | null, prefix: string, number: number | string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.put(`/support-documents/${prefix}/${number}/cancel`, {});
    }

    detectInvoicingGaps(uid: string, cid: string | null, prefix?: string, page = 1, limit = 10): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        const params = new URLSearchParams({ page: String(page), limit: String(limit) });
        if (prefix) params.append('prefix', prefix);
        return httpClient.get(`/sells/audit/gaps?${params.toString()}`);
    }

    linkGapInvoice(uid: string, cid: string | null, prefix: string, number: number): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/sells/audit/link`, { prefix, number });
    }

    discardGapInvoice(uid: string, cid: string | null, prefix: string, number: number): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/sells/audit/discard`, { prefix, number });
    }

    cancelGapWithCreditNote(uid: string, cid: string | null, prefix: string, number: number, discrepancy_code = 2, notes = "Anulación de factura huérfana / auditoría"): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/sells/audit/cancel-credit-note`, { prefix, number, discrepancy_code, notes });
    }

    voidGapConsecutive(uid: string, cid: string | null, prefix: string, number: number, reason = "Consecutivo no utilizado / anulado internamente"): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post(`/sells/audit/void-consecutive`, { prefix, number, reason });
    }
}
